import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable, of } from 'rxjs';

import { RequisitionAutoSaveDispatcherService } from '../services/requisition-auto-save-dispatcher.service';

@Injectable()
export class RequisitionDetailsGuard {
  constructor(private saveDispatcher: RequisitionAutoSaveDispatcherService) {}

  public canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean> {
    // Block below handles auto-save of a requisition when user switches between requisition editor tabs
    if (/requisitions\/[a-zA-Z0-9-]+\//.test(nextState.url)) {
      this.saveDispatcher.save();
      return this.saveDispatcher.allowChangeTab$;
    }

    return of(true);
  }
}
